<template>
    <div>
        <div class="uk-grid">
            <div class="uk-width-4-5">
                <h2>Top Clients</h2>
            </div>
            <div class="uk-width-1-5 uk-text-right">
                <div class="uk-button-group lam-graph-filter">
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === '0'}"
                        @click.prevent="$emit('set-state-value', 'scope', '0')"
                    >
                        1 year
                    </base-button>
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === '1'}"
                        @click.prevent="$emit('set-state-value', 'scope', '1')"
                    >
                        2 years
                    </base-button>
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === '2'}"
                        @click.prevent="$emit('set-state-value', 'scope', '2')"
                    >
                        3 years
                    </base-button>
                </div>
            </div>
        </div>
        <cards
            v-if="!!firm_palette"
            id="prospectives-dashboard-top-clients"
            :cards="cards"
            :selectable="false"
            :flex="true"
        >
            <template slot="card" slot-scope="props">
                <div v-if="props.card.id === 'clients-by-fee'">
                    <top-clients
                        dataset-id="fee"
                        :raw-data="dataset"
                        :filter="state.scope"
                        legend-position="bottom"
                        :utility-data="firm_palette"
                    />
                </div>
                <div v-else-if="props.card.id === 'clients-by-project'">
                    <top-clients
                        dataset-id="projects"
                        :raw-data="dataset"
                        :filter="state.scope"
                        legend-position="bottom"
                        :utility-data="firm_palette"
                    />
                </div>
            </template>
        </cards>
    </div>
</template>

<script type="text/javascript">
import uses_color_palette from "../../../mixins/UsesColorPalette"

import Cards from "../../../ui/Cards"
import BaseButton from "../../../ui/BaseButton"
import TopClients from "../../dashboard/Graphs/TopClients"

export default {
    mixins: [uses_color_palette],
    components: {
        Cards,
        BaseButton,
        TopClients
    },
    mounted () {
        this.reset_ui()
    },
    watch: {
        dataset: "reset_ui"
    },
    methods: {
        reset_ui () {
            if(!this.dataset) return
            const firm_palette = {}
            this.dataset.forEach(range_data => {
                range_data.forEach(dataset => {
                    dataset.forEach(firm => {
                        if(!firm_palette[firm.name]) {
                            const full_palette = this.extended_palette
                            firm_palette[firm.name] = full_palette[(Object.keys(firm_palette).length % full_palette.length)]
                        }
                    })
                })
            })
            this.firm_palette = firm_palette
        }
    },
    computed: {
        cards () {
            const cards = [
                {
                    id: "clients-by-fee",
                    title: "By Fee",
                    classes: { "uk-width-small-1-1": true, "uk-width-large-1-2": true }
                },
                {
                    id: "clients-by-project",
                    title: "By Projects",
                    classes: { "uk-width-small-1-1": true, "uk-width-large-1-2": true }
                }
            ]

            return cards
        }
    },
    props: {
        dataset: {
            required: true
        },
        state: {
            required: true
        }
    },
    data () {
        return {
            firm_palette: null
        }
    }
}
</script>
